import { render, staticRenderFns } from "./m-user-details.vue?vue&type=template&id=54cb4d2c&scoped=true&lang=pug"
import script from "./m-user-details.vue?vue&type=script&lang=js"
export * from "./m-user-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb4d2c",
  null
  
)

export default component.exports